import * as Yup from 'yup';
import { phoneNumberFormatter } from './phoneNumber.validation';

// REGISTRAION VALIDATION SCHEMA
export const OrganisationProfileSchema = Yup.object().shape({
  contactName: Yup.string()
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters')
    .required('Entity, person or team name is required'),
  contactEmail: Yup.string()
    .required('Email address is required')
    .email('Invalid email address')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 Characters'),
  contactPhoneNumber: Yup.string()
    .required('Contact phone number is required')
    .max(16, 'Maximum 16 Characters.')
    .test(
      'validate-cpnumber',
      'Please enter valid phone number',
      (value): any => {
        return phoneNumberFormatter({ phoneNumber: value || '' }).isValid();
      }
    ),
  contactEmergencyPhone: Yup.string()
    .test(
      'validate-cpnumber',
      'Please enter valid phone number',
      (value): any => {
        const phoneNumber = value || '';
        return phoneNumberFormatter({ phoneNumber }).isValid();
      }
    )
    .max(16, 'Maximum 16 Characters')
    .required('Emergency phone number is required'),
  contactUrl: Yup.string()
    .transform((originalValue) => {
      const doesNotStartWithHttp =
        originalValue &&
        !(
          originalValue.startsWith('http://') ||
          originalValue.startsWith('https://')
        );

      if (doesNotStartWithHttp) {
        return `http://${originalValue}`;
      }

      return originalValue;
    })
    .url('URL not recognised')
});
